import { render, staticRenderFns } from "./AlarmPointsTable.vue?vue&type=template&id=5e895a9e&scoped=true"
import script from "./AlarmPointsTable.vue?vue&type=script&lang=ts"
export * from "./AlarmPointsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e895a9e",
  null
  
)

export default component.exports